import { render, staticRenderFns } from "./GeoTemplate.vue?vue&type=template&id=63b1ddf2&"
import script from "./GeoTemplate.vue?vue&type=script&lang=js&"
export * from "./GeoTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports